import './App.css';
import React from "react";
import {Image} from "primereact/image";
import LicenseGenerator from "./License-Generator/LicenseGenerator";
import LicenseList from "./License-List/LicenseList";

function App() {
  //const getBasename = path => path.substring(0, path.lastIndexOf('/'));
  const nimLogo = require('./images/logo-dark.png');
  return (
        <div className="App">
            <div className={'generatorClass'}>
                <div className={'generatorMain align-content-center'}>
                    <div>
                        <Image src={nimLogo} alt='Nimesa'/>
                        <LicenseGenerator/>
                        <LicenseList/>
                    </div>
                </div>
            </div>
        </div>
  );
}
export default App;
